import { render, staticRenderFns } from "./HouseConsumption.vue?vue&type=template&id=3c6e56b6&scoped=true&"
import script from "./HouseConsumption.vue?vue&type=script&lang=ts&"
export * from "./HouseConsumption.vue?vue&type=script&lang=ts&"
import style0 from "./HouseConsumption.vue?vue&type=style&index=0&id=3c6e56b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6e56b6",
  null
  
)

export default component.exports